const images = {
  actions: {
    errorImage(context, event) {
      event.src = require("@/assets/preview.png");
    },
  },
};

export default images;
